/**
 * Batched low lift test 5, test 1:
 * PRD: https:www.notion.so/faire/Low-lift-testing-Batch-5-
 * 528305362d4d4455a8d8ad0edaf65767?pvs=4#04129661df5e4584b3b0ef79a3654321
 */
export const BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124 = 'BATCH_5_HOMEPAGE_FIRST_SECTION_COPY_TEST_102124';
